const Bg = () => <div className="starfield opacity-60" aria-hidden />;

export const VinScan = () => (
  <div className="tile-media" data-testid="tile-vin">
    <Bg />
    <div className="relative w-[78%] overflow-hidden rounded-lg border border-line/70 bg-ink/80 px-4 py-3 font-mono text-[13px] tracking-[0.18em] text-silver">
      1HGCM82633A004352
      <span className="anim-scan absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-transparent via-cyan/40 to-transparent" />
    </div>
    <span className="absolute right-6 top-5 rounded-full border border-emerald-400/40 bg-emerald-500/10 px-2 py-0.5 font-mono text-[9px] tracking-[0.2em] text-emerald-300">MATCH</span>
    <p className="tile-caption">Brand · Model · Year → Pattern set</p>
  </div>
);

const pieces = [
  [4, 6, 30, 22], [36, 6, 22, 16], [60, 6, 34, 24], [4, 30, 18, 26], [24, 24, 32, 30], [60, 32, 34, 24], [4, 58, 46, 20], [52, 58, 42, 20],
];
export const Nesting = () => (
  <div className="tile-media" data-testid="tile-nesting">
    <Bg />
    <svg viewBox="0 0 100 80" className="relative h-[120px] w-auto">
      <rect x="1" y="1" width="98" height="78" rx="3" fill="rgba(11,16,27,.9)" stroke="rgba(47,128,255,.35)" />
      {pieces.map(([x, y, w, h], i) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={w} height={h} rx="2" fill="rgba(0,240,255,.14)" stroke="#00f0ff" strokeWidth=".6" className="anim-blink" style={{ animationDelay: `${i * 0.25}s`, animationDuration: "3.5s" }} />
      ))}
    </svg>
    <span className="absolute right-6 top-5 rounded-full border border-cyan/30 bg-cyan/10 px-2 py-0.5 font-mono text-[9px] tracking-[0.2em] text-cyan">-25% FILM</span>
    <p className="tile-caption">60" roll · auto-nested</p>
  </div>
);

export const Calibration = () => (
  <div className="tile-media" data-testid="tile-calibration">
    <Bg />
    <svg viewBox="0 0 200 90" className="relative h-[110px] w-auto">
      <path d="M10 70 C 60 5, 140 5, 190 70" fill="none" stroke="#2f80ff" strokeWidth="1.5" className="anim-dash" />
      <line x1="10" y1="70" x2="60" y2="20" stroke="rgba(0,240,255,.5)" strokeDasharray="2 2" />
      <line x1="190" y1="70" x2="140" y2="20" stroke="rgba(0,240,255,.5)" strokeDasharray="2 2" />
      {[[10, 70], [60, 20], [140, 20], [190, 70]].map(([x, y]) => <rect key={`${x}${y}`} x={x - 3} y={y - 3} width="6" height="6" fill="#00f0ff" />)}
      <line x1="10" y1="84" x2="190" y2="84" stroke="rgba(201,204,210,.5)" />
      {Array.from({ length: 19 }, (_, i) => <line key={i} x1={10 + i * 10} y1="80" x2={10 + i * 10} y2={i % 5 === 0 ? 88 : 86} stroke="rgba(201,204,210,.6)" strokeWidth=".8" />)}
    </svg>
    <p className="tile-caption">254 mm test square · 1:1 verified</p>
  </div>
);

export const CloudSync = () => (
  <div className="tile-media" data-testid="tile-sync">
    <Bg />
    <div className="relative h-[120px] w-[120px]">
      {[1, 0.7, 0.4].map((s) => <span key={s} className="absolute inset-0 rounded-full border border-blue/30" style={{ transform: `scale(${s})` }} />)}
      <span className="anim-sweep absolute inset-0 rounded-full" style={{ background: "conic-gradient(from 0deg, rgba(0,240,255,.45), transparent 60deg)" }} />
      <span className="absolute left-[62%] top-[28%] h-1.5 w-1.5 rounded-full bg-cyan shadow-[0_0_10px_#00f0ff]" />
      <span className="absolute left-[30%] top-[64%] h-1.5 w-1.5 rounded-full bg-cyan shadow-[0_0_10px_#00f0ff]" />
    </div>
    <span className="absolute right-6 top-5 rounded-full border border-blue/40 bg-blue/10 px-2 py-0.5 font-mono text-[9px] tracking-[0.2em] text-blue-text">+2026 MODELS</span>
    <p className="tile-caption">New vehicles load automatically</p>
  </div>
);

export const DualOs = () => (
  <div className="tile-media" data-testid="tile-os">
    <Bg />
    <div className="relative grid w-[78%] grid-cols-2 gap-3">
      {["WINDOWS 10 / 11", "MACOS 13+"].map((l) => (
        <div key={l} className="rounded-lg border border-line/70 bg-ink/80 p-3">
          <div className="mb-2 flex gap-1"><span className="h-1.5 w-1.5 rounded-full bg-red-400/70" /><span className="h-1.5 w-1.5 rounded-full bg-amber-300/70" /><span className="h-1.5 w-1.5 rounded-full bg-emerald-400/70" /></div>
          <div className="h-1.5 w-3/4 rounded bg-blue/40" /><div className="mt-1.5 h-1.5 w-1/2 rounded bg-blue/25" />
          <p className="mt-3 font-mono text-[8px] tracking-[0.2em] text-silver/70">{l}</p>
        </div>
      ))}
    </div>
    <p className="tile-caption">Same patterns · both platforms</p>
  </div>
);

export const Unlimited = () => (
  <div className="tile-media" data-testid="tile-unlimited">
    <Bg />
    <div className="relative flex items-center gap-1.5">
      {["9", "9", "9", "9", "9", "9"].map((d, i) => (
        <span key={i} className="flex h-14 w-9 items-start justify-center overflow-hidden rounded-md border border-line/70 bg-ink/80 font-mono text-2xl text-white">
          <span className="anim-rise flex flex-col" style={{ animationDelay: `${i * -0.7}s` }}>{Array.from({ length: 10 }, (_, n) => <span key={n} className="flex h-14 items-center justify-center">{(9 - n)}</span>)}</span>
        </span>
      ))}
      <span className="ml-1 font-mono text-2xl text-cyan">+</span>
    </div>
    <span className="absolute right-6 top-5 rounded-full border border-emerald-400/40 bg-emerald-500/10 px-2 py-0.5 font-mono text-[9px] tracking-[0.2em] text-emerald-300">UNLOCKED</span>
    <p className="tile-caption">Cuts and counting · no per-cut fees</p>
  </div>
);
